exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./icon.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/asserts/styles/all.css
// module id = 182
// module chunks = 0